import React from 'react'
import { Container, Jumbotron } from 'reactstrap'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const HeroImage = styled.div`
  position: relative;
  height: 191px;
  width: 100%;
  background-image: url(${props => props.src});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center top;
  @media (min-width: 575.98px) and (max-width: 768px) {
    height: 225px;
  }
  @media (max-width: 575.98px) {
    height: 200px;
  }
`

const JumbotronStyled = styled(Jumbotron)`
  background-color: white;
  border-radius: 0px;
  padding: 0px;

  @media screen and (min-width: 768px) {
    display: inline-table;
  }
`

const HeroContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  position: relative;
  padding-top: 15px;
  margin-bottom: 15px;

  @media screen and (min-width: 768px) {
    flex-direction: row;
    text-align: left;
    top: auto;
    position: relative;
  }
`

export default ({ heroSrc = '', heroAlt = '', imgSrc = '', imgAlt = '', children, data }) => (
  <Wrapper>
    <HeroImage src={heroSrc} alt={heroAlt} />
    <JumbotronStyled>
      <HeroContainer>
        {children}
      </HeroContainer>
    </JumbotronStyled>
  </Wrapper>
)
